export default __webpack_public_path__ + "static/media/cash.632a51f2.svg";